import React from "react";
import { Link } from "react-router-dom";
import { serviceAreas } from "../../data/serviceAreas";
// @ts-ignore
import "./ServiceAreaLinks.css";

/* Sitewide internal links to the city landing pages. Rendered above the footer
   on every route so the new pages are one click from anywhere on the site. */
export default function ServiceAreaLinks(): JSX.Element {
  return (
    <section className="area-links-band" aria-label="Service areas">
      <div className="container">
        <p className="area-links-heading">
          Limo service across South Jersey &amp; Philadelphia
        </p>
        <ul className="area-links-list">
          {serviceAreas.map((area) => (
            <li key={area.slug}>
              <Link
                to={`/limo-service/${area.slug}`}
                title={`Limo service in ${area.city}, ${area.state}`}
              >
                {area.city}, {area.state}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/service-areas" title="All GS Limo Elite service areas">
              All service areas
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
}
